import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './features/auth/styles/login.css';
// passkey UI (PasskeySignInButton 等) の共有スタイル。@auth/ui-react が同梱する CSS。
import '@auth/ui-react/styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
